export default __webpack_public_path__ + "static/media/problema-06.25ff1dd6.webp";